import React from 'react';
import {Link} from 'react-router-dom';
import I18n from 'app/i18n';
import {getLinkPath} from 'app/utils/link_helper';
import type {FaqCategoryKey} from 'app/utils/knowledgeCenter/categories';
import type {FaqCategorySummary} from 'app/utils/knowledgeCenter/faqGrouping';

interface Props {
    categories: FaqCategorySummary[]
    activeCategory?: FaqCategoryKey
}

const KnowledgeCenterCategoryNav = ({categories, activeCategory}: Props): React.ReactElement => <nav
    className="knowledge-center__nav"
    aria-label={I18n.t('knowledge_center.title')}
>
    {categories.map(({category, count, label}: FaqCategorySummary) => {
        const isActive = activeCategory === category;
        const linkClassName = `knowledge-center__nav-link ${isActive ? 'knowledge-center__nav-link--active' : ''}`;

        return (
            <Link
                key={category}
                to={getLinkPath(`/faq/category/${category}`)}
                className={linkClassName}
            >
                <span>{label}</span>
                <i>{count}</i>
            </Link>
        );
    })}
</nav>;
export default KnowledgeCenterCategoryNav;
